import axios from 'axios';
import authHeader from '@/services/auth.header';
import { HTTP } from '@/http/config'; 
import { AnyObject } from 'yup';
const API_URL = HTTP.api_url;
class TipoEspService {
    async getIndex():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'tipoespecialidads', { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }  
    async getSearch(search):Promise<AnyObject>{    
          const response = await axios.get(API_URL + `tipoespecialidads`, 
          { 
            params: search,
            headers: authHeader() 
          })
           .then(response => {        
             //console.log(JSON.stringify(response.data.data))
             return response.data;
           }).catch(error => {
             const dataError = JSON.stringify(error.response.data)
             console.log(dataError)      
           });
           return  response;
          }  
    async getlist(pageNumber):Promise<AnyObject>{    
        const response = await axios.get(API_URL + `tipoespecialidads?page=${pageNumber}`, { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        } 

        async postCreated(especialidad):Promise<AnyObject> {    
            const response = await axios.post(API_URL + 'tipoespecialidads', 
               especialidad, 
              { headers: authHeader() }
            )
            .then(response =>{
             // console.log(response.data)
              return response.data;
            })
            .catch(error=>{
              const dataError = error.response.data
              console.log(dataError)   
              return dataError;
            });
            return response;
          }
   
          async postUpdate(id,especialidad):Promise<AnyObject> {    
             const response = await axios.put(API_URL + `tipoespecialidads/${id}`,  
               {id:Number(id),...especialidad},     
               { headers: authHeader() },      
             )
             .then(response =>{
               //console.log(response.data)
               return response?.data;
             })
             .catch(error=>{
               const dataError = error.response.data
               console.log(dataError)   
               return dataError;
             });
             return response;
           }
           async getEdit(id):Promise<AnyObject[]>{
            const response = await axios.get(API_URL + `tipoespecialidads/${id}`,     
             { headers: authHeader() }
           )
           .then(response =>{     
             return response?.data;
           })
           .catch(error=>{
             const dataError = error.response.data
             console.log(dataError)   
             return dataError;
           });
           return response;
         }
       
          async getDelete(id):Promise<AnyObject>{
            const response = await axios.delete(API_URL + `tipoespecialidads/${id}`,     
             { headers: authHeader() }
           )
           .then(response =>{      
             return response?.data;
           })
           .catch(error=>{
             const dataError = error.response.data
             console.log(dataError)   
             return dataError;
           });
           return response;
         }

        async getListTipo():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'tipoespecialidads/list-especialidad', { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }  


}
export default new TipoEspService()
